import { ensureValidUrlWithoutTrailingSlash, UrlWithoutTrailingSlash } from '@/settings/public'

/**
 * Get the application host dynamically
 * - Uses NEXT_PUBLIC_HOST env var if set (required for production/staging)
 * - Falls back to window.location.origin on client side
 * - Falls back to localhost:8080 for local development
 *
 * ⚠️ IMPORTANT: Always set NEXT_PUBLIC_HOST in production/staging environments!
 * Server-side code (SSR, API routes) cannot access window.location and will
 * fall back to localhost:8080 if NEXT_PUBLIC_HOST is not set.
 */
export function getAppHost(): UrlWithoutTrailingSlash {
  // Priority 1: Use explicit env var if set
  if (process.env.NEXT_PUBLIC_HOST) {
    return ensureValidUrlWithoutTrailingSlash(process.env.NEXT_PUBLIC_HOST)
  }

  // Priority 2: Use current origin on client side
  if (typeof window !== 'undefined') {
    return ensureValidUrlWithoutTrailingSlash(window.location.origin)
  }

  return ensureValidUrlWithoutTrailingSlash('http://localhost:8080')
}